import {
    getCompanies,
    deleteCompanie,
    deleteCompanies,
    exportCompaniesExport,
} from "@/http/api/company";
import {
    getEnumMetaData,
    getEnumMetaKey
} from "@/utils/getEnumMeta";
import {
    dateFormatYMD
} from "@/common/filters";

import {
    debounce
} from "@/utils/debounce";
import headerTop from "@/components/HeaderTop";
export default {
    components: {
        headerTop
    },
    computed: {
        path() {
            return this.$route.name;
        }
    },
    data() {
        const generateData = () => {
            const data = [];
            const tabTits = [
                "分销商名称",
                "分销商类型",
                "分销商状态",
                "加盟渠道来源",
                "联系电话",
                // "电子邮箱",
                // "公司法人",
                // "营业执照号码",
                "工商注册地址",
                "法人",
                "地址",
            ];
            const pinyin = [
                "jiamengshangmingcheng",
                "jiamengshangleixing",
                "jiamengshangzhuangtai",
                "jiamengshanglaiyuan",
                "lianxidianhua",
                // "lianxirenyouxiang",
                // "gongsifaren",
                // "yingyezhizhaohaoma",
                "gongshangzhucedizhi",
                "faren",
                "jiamengshangdizhi",
            ];
            tabTits.forEach((tabTit, index) => {
                data.push({
                    label: tabTit,
                    key: tabTit,
                    pinyin: pinyin[index]
                });
            });
            return data;
        };
        return {
            headerText: "分销商管理",
            companies: [],
            searchSelect: "全文搜索",
            //搜索类型选择数据
            searchTypeOptions: [
                {
                    key: "全文搜索",
                    value: "名称/电话/邮箱"
                },{
                    key: "名称",
                    value: "请输入名称"
                }, {
                    key: "联系方式",
                    value: "请输入联系电话"
                },],
            searchFilter: "", //搜索内容
            filterSelectPlaceholder: '名称/电话/邮箱',
            //分销商类型/状态
            companyStatusOptions: [],
            companyTypeOptions: [],
            //职位选择数据
            dateValue: '请选择时间',
            dateOptions: [{
                key: "全部",
                value: "全部"
            }, {
                key: "自定义时间",
                value: "自定义时间"
            }],
            //参数集合
            pageIndex: 1,
            query: {
                filter: "",
                condition: "Name",
                timeCondition: "CreationTime",
                startTime: "",
                endTime: "",
                status: "",
                type: "",
                sorting: "",
                skipCount: 0,
                maxResultCount: 30,
            },
            filterDate: '', //选择日期范围
            filterDateReadonly: true, //禁止选择日期范围
            tabTitData: generateData(), //字段穿梭框数据
            tableTitleKey: ["分销商名称", "分销商类型", "分销商状态", "加盟渠道来源", "联系电话", "电子邮箱", "公司法人", "营业执照号码", "法人", "地址", "操作"], //穿梭框已选择字段名
            isShowFiltrate: false, //字段穿梭框
            isLoading: false, //表格数据加载中
            multipleSelection: [], //勾选数据
            total: 0, //总条数

            //筛选
            typeFilter: '',
            statusFilter: '',
            //权限
            permissions: {}
        };
    },
    methods: {
        // 排序
        changeSort(val) {
            this.query.sorting =
                val.order == "descending" ?
                    `${val.prop} desc` :
                    val.order == "ascending" ?
                        `${val.prop} asc` :
                        "";
            this.getCompanies();
        },
        // 编辑分销商
        editCompany(index, rowData) {
            if (!this.permissions["Company.Update"]) {
                this.$message.warning({
                    message: `您暂无管理分销商门店权限`,
                    showClose: true,
                });
                return;
            }
            this.$router.push({
                path: `/channel/business/management/${rowData.id}`, // ${id}:id的值
            });
        },
        // 添加分销商
        createCompany() {
            if (this.permissions["Company.Create"]) {
                this.$router.push('/channel/business/create')
            } else {
                this.$message.warning({
                    message: `您暂无添加分销商权限`,
                    showClose: true,
                });
            }
        },
        //删除
        deleteCompanie(index, id) {
            if (this.permissions["Company.Delete"]) {
                this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteCompanie(id).then(res => {
                        if (res.code == 10200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!',
                                showClose: true
                            });
                            this.getCompanies();
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除',
                        showClose: true
                    });
                });
            } else {
                this.$message.warning({
                    message: `您暂无删除分销商权限`,
                    showClose: true,
                });
            }
        },
        //批量删除
        deleteCompanys() {
            if (this.permissions["Company.Delete"]) {
                if (this.multipleSelection.length == 0) {
                    this.$message({
                        showClose: true,
                        message: '请选择分销商',
                        type: 'warning'
                    });
                    return;
                }
                this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var idArr = this.multipleSelection.map(item => item.id);
                    var ids = idArr.join('&ids=');
                    deleteCompanies(ids).then(res => {
                        if (res.code == 10200) {
                            this.$message({
                                type: 'success',
                                message: '批量删除成功!',
                                showClose: true
                            });
                            this.getCompanies();
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除',
                        showClose: true
                    });
                });
            } else {
                this.$message.warning({
                    message: `您暂无删除分销商权限`,
                    showClose: true,
                });
            }
        },
        // 列表搜索
        handleFilterChange(filters) {
            if (filters.type) {
                this.query.type = filters.type[0];
                this.typeFilter = getEnumMetaKey(this.$store.getters.enumMetadata, 'CompanyType', filters.type[0]);
            } else if (filters.status) {
                this.query.status = filters.status[0];
                this.statusFilter = getEnumMetaKey(this.$store.getters.enumMetadata, 'CompanyStatus', filters.status[0]);
            }
            this.getCompanies();
        },
        //清空筛选条件
        clearFilters(type) {
            if (type == 'type') {
                this.typeFilter = '';
                this.query.type = '';
                this.$refs.multipleTable.clearFilter('type');
            } else if (type == 'status') {
                this.statusFilter = '';
                this.query.status = '';
                this.$refs.multipleTable.clearFilter('status');
            } else {
                this.typeFilter = '';
                this.query.type = '';
                this.$refs.multipleTable.clearFilter('type');
                this.statusFilter = '';
                this.query.status = '';
                this.$refs.multipleTable.clearFilter('status');
            }
            this.getCompanies();
        },
        // 选择日期
        selectDate(e) {

            this.filterDateReadonly = true;
            if (e == "今天") {
                this.filterDate = this.setFilterDays(0, 0);
            } else if (e == "昨天") {
                this.filterDate = this.setFilterDays(1, 1);
            } else if (e == "近七天") {
                this.filterDate = this.setFilterDays(6, 0);
            } else if (e == "全部") {
                this.filterDate = this.setFilterDays(366, 0);
            } else {
                this.filterDate = "";
                this.filterDateReadonly = false;
                this.getCompanies();
                return;
            }
            this.getCompanies();
        },
        //关闭穿梭框
        closeFiltrate() {
            this.isShowFiltrate = false;
        },
        //筛选穿梭框
        filterMethod(query, item) {
            return item.pinyin.indexOf(query) > -1 || item.label.indexOf(query) > -1;
        },
        // 选择分销商状态/类型
        selectCompanyStatus(e) {
            this.getCompanies();
        },
        selectCompanyType(e) {
            this.getCompanies();
        },
        //搜索类型选择
        filterSelect(val) {
            this.filterSelectPlaceholder = val;
            if (val == "请输入分销商名称前缀") {
                this.query.condition = "Name";
            } else if (val == "请输入联系电话") {
                this.query.condition = "PhoneNumber";
            } else if (val == "名称/电话") {
                this.query.condition = "";
            }
        },
        //下载
        derive() {
            exportCompaniesExport().then((res) => {
                const content = res;
                const blob = new Blob([content]);
                if ("download" in document.createElement("a")) {
                    // 非IE下载
                    const elink = document.createElement("a");
                    elink.download = "分销商列表.xlsx";
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob);
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, "分销商列表.xlsx");
                }
            });
        },
        //分页 每页数量切换
        handleSizeChange(val) {
            this.query.maxResultCount = val;
            this.getCompanies();
        },
        //分页 切换页面
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getCompanies();
        },
        //勾选表格数据
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 获取n天前到现在
        setFilterDays(starNum, endNum) {
            let start = new Date(
                new Date().getTime() - 24 * 60 * 60 * 1000 * starNum
            );
            let end = new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * endNum);
            return [start.Format("yyyy-MM-dd hh:mm:ss"), end.Format("yyyy-MM-dd hh:mm:ss")];
        },
        // 获取分销商列表
        getCompanies(v) {
            this.isLoading = true;
            this.companies = [];

            if (this.searchFilter) {
                this.query.filter = this.searchFilter;
            } else {
                delete this.query.filter;
            }

            if (this.filterDate) {
                this.query.startTime = this.filterDate[0];
                this.query.endTime = this.filterDate[1];
            } else {
                this.query.startTime = "";
                this.query.endTime = "";
            }

            if (v == "refresh") {
                this.query = this.$options.data().query;
            } else {
                this.query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount;
            }
            getCompanies(this.query).then(res => {
                this.isLoading = false;
                this.companies = res.result.items;
                this.total = res.result.totalCount;
            })
        },
    },
    created() {
        this.$watch(
            "searchFilter",
            debounce((val) => {
                if (!val) {
                    this.getCompanies();
                }
            }, 200)
        );
    },
    mounted() {
        this.permissions = this.$store.getters.permissions;
        // 获取列表
        this.getCompanies();
        //分销商类型
        this.companyTypeOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyType');
        this.companyTypeOptions = this.companyTypeOptions.map(item => {
            return {
                text: item.value,
                value: item.key
            }
        });
        //分销商状态
        this.companyStatusOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyStatus');
        this.companyStatusOptions = this.companyStatusOptions.map(item => {
            return {
                text: item.value,
                value: item.key
            }
        });
    },
};